"use strict";
/*
 * Created on 03 01 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ValidationResult_1 = require("../../core/model/errors/ValidationResult");

var UserInfo_1 = require("../../user/model/UserInfo");

var RealImpactValue_1 = require("./RealImpactValue");

var ReleaseState_1 = require("./ReleaseState");

var ReleaseType_1 = require("./ReleaseType");

var ReleaseWorkflowType_1 = require("./ReleaseWorkflowType");
/**
 * Abstraction of entities which encapsulates data to release new prices.
 *
 * @author JMe
 */


var AbstractRelease =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(AbstractRelease, _DomainObject_1$Domai);

  /**
   * @param id internal id of release
   * @param name name of release
   * @param description free description of release
   * @param releaseType type of release (regular, simulation, sellout)
   * @param created time of creation of release entity
   * @param createdBy user who created this release entity
   * @param lastModified time of last modification (last saved)
   * @param lastModifiedBy user who modified this release as last (last saved)
   * @param priceListTypeId price list type id from {@link PriceListSettings settings}
   * @param priceListType price list type from {@link PriceListSettings settings}
   * @param productCategoryIds product categories that should be processed (included) within the release (categories can be determined by
   *        user or it may be resolved dynamically based on automatically selected products (valid for some type of release, e.g. sellout)
   * @param releaseParts parts of release with separate workflow (e.g. approval, submission, ...)
   * @param workflowType type of workflow
   * @param state current release state; it is synchronized from individual states of release parts
   * @param calcWorkflowCaseId id of case of a workflow which processes initial calculation of optimal prices in the entire release.
   * @param exportWorkflowCaseId case ID of a workflow which processes a preparation for release's export.
   *        Is null if there has not yet been any export or the last export has been abandoned.
   * @param exportProgressMonitorId ID of a progress monitor associated with this release's export (an evaluation
   *        of repricing possibility constraints). If null then the there is currently no such running operation.
   * @param priceValidityStartDate expected start date of new price validity
   * @param totalPriceChangeLimit number of items to limit maximum number of items with changed prices in the release (can be bound to
   *        site for specific type of release)
   * @param exported date and time of last prices export; null if not exported (yet)
   * @param cmDeadline deadline for the release. Serves for urgencies between CM and SCM/SM, ...
   * @param favourite indicates whether release is favourite one
   * @param validationResult validation messages (alerts)
   * @param realImpact contains real (not forecasted) values of some business relevant metrics for already valid releases.
   *        Filled only for impact report.
   * @param calcProgressMonitorId id of progress monitor for optimal prices calculation
   * @param computingProcessId ID of application instance working with this release (performing price calculations)
   */
  function AbstractRelease(id, name, description, releaseType, // todo reconsider change of type to string to be more dynamic
  created, createdBy, lastModified, lastModifiedBy, priceListTypeId, priceListType, productCategoryIds, // todo verify this if it should be part of abstraction at all
  releaseParts, workflowType, // todo reconsider change of type to string to be more dynamic
  // todo validate this according to sellout workflow (reconsider change of type to string to be more dynamic)
  state, calcWorkflowCaseId, exportWorkflowCaseId, exportProgressMonitorId, priceValidityStartDate, totalPriceChangeLimit, exported, cmDeadline, // missing for some workflow types
  favourite, // todo reconsider change of type to object to be more extendable if it will not be global
  validationResult, realImpact, calcProgressMonitorId, // LOG-4039
  computingProcessId) {
    var _this;

    _classCallCheck(this, AbstractRelease);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbstractRelease).call(this));
    _this.id = id;
    _this.name = name;
    _this.description = description;
    _this.releaseType = releaseType;
    _this.created = created;
    _this.createdBy = createdBy;
    _this.lastModified = lastModified;
    _this.lastModifiedBy = lastModifiedBy;
    _this.priceListTypeId = priceListTypeId;
    _this.priceListType = priceListType;
    _this.productCategoryIds = productCategoryIds;
    _this.releaseParts = releaseParts;
    _this.workflowType = workflowType;
    _this.state = state;
    _this.calcWorkflowCaseId = calcWorkflowCaseId;
    _this.exportWorkflowCaseId = exportWorkflowCaseId;
    _this.exportProgressMonitorId = exportProgressMonitorId;
    _this.priceValidityStartDate = priceValidityStartDate;
    _this.totalPriceChangeLimit = totalPriceChangeLimit;
    _this.exported = exported;
    _this.cmDeadline = cmDeadline;
    _this.favourite = favourite;
    _this.validationResult = validationResult;
    _this.realImpact = realImpact;
    _this.calcProgressMonitorId = calcProgressMonitorId;
    _this.computingProcessId = computingProcessId;
    return _this;
  }
  /**
   * Product categories for parts of release. Level of these categories is configured in ReleaseConfig (category plan level is expected).
   * For these categories, separate workflow processes are started after the release is opened.
   * Note: In 4BOX product structure, product category levels are named:
   * Total (one root category) (level 1), Unit Directors (2), Senior category managers (3),
   * Category managers (4), category plans (5), 4BOX (6).
   */


  _createClass(AbstractRelease, [{
    key: "getPartCategoryIds",
    value: function getPartCategoryIds() {
      return this.releaseParts.map(function (part) {
        return part.productCategoryId;
      });
    }
    /**
     * See {@link getPartCategoryIds}. Only approved release parts are considered.
     */

  }, {
    key: "getApprovedPartCategoryIds",
    value: function getApprovedPartCategoryIds() {
      return this.releaseParts.filter(function (part) {
        return part.approved;
      }).map(function (part) {
        return part.productCategoryId;
      });
    }
    /**
     * Updates release parts using given function and returnes updated release (that can be later stored in DB).
     * @param update
     */

  }, {
    key: "withUpdatedReleaseParts",
    value: function withUpdatedReleaseParts(update) {
      return this.copy('releaseParts', this.releaseParts.map(function (releasePart) {
        return update(releasePart);
      }));
    }
    /**
     * Returns true if an export of the release is being prepared.
     * No release's parts can be edited in that case.
     */

  }, {
    key: "preparingExport",
    value: function preparingExport() {
      return this.state === ReleaseState_1.ReleaseState.ExportEditing || this.state === ReleaseState_1.ReleaseState.ExportChecking;
    }
  }, {
    key: "getWeek",
    value: function getWeek() {
      // TODO RBe: Review: Implement week from creation date? Where is this used?
      return this.created.isoWeeksInYear();
    }
    /**
     * Returns true if release is in the state where prices can be generally edited.
     * Access rights on the release part level and user-level must be further checked.
     */

  }, {
    key: "canBeEdited",
    value: function canBeEdited() {
      return this.state === ReleaseState_1.ReleaseState.Opened || this.state === ReleaseState_1.ReleaseState.ExportFailed || this.state === ReleaseState_1.ReleaseState.ExportEditing || this.state === ReleaseState_1.ReleaseState.Approved
      /* normally editable in export page by the requirement */
      ;
    }
    /**
     * Returns true if some release part is finally approved.
     */

  }, {
    key: "isSomeReleasePartApproved",
    value: function isSomeReleasePartApproved() {
      return this.releaseParts.some(function (part) {
        return part.approved !== null;
      });
    }
    /**
     * Returns true if workflows for release parts were initiated.
     */

  }, {
    key: "hasReleasePartWorkflows",
    value: function hasReleasePartWorkflows() {
      return this.releaseParts.some(function (part) {
        return part.workflowCaseId !== null;
      });
    }
    /**
     * Returns only approved release parts.
     */

  }, {
    key: "approvedReleaseParts",
    value: function approvedReleaseParts() {
      return this.releaseParts.filter(function (part) {
        return part.approved !== null;
      });
    }
    /**
     * Returns release part for given product category or throws an error.
     * @param categoryId
     */

  }, {
    key: "requireReleasePartForCategory",
    value: function requireReleasePartForCategory(categoryId) {
      var part = this.releaseParts.find(function (p) {
        return p.productCategoryId === categoryId;
      });

      if (part === undefined) {
        throw new Error("Release part for category ".concat(categoryId, " not found in release ").concat(this.id));
      }

      return part;
    }
    /**
     * Returns true if some category-manager deadline was missed.
     */

  }, {
    key: "isSomeCmDeadlineMissed",
    value: function isSomeCmDeadlineMissed() {
      return this.releaseParts.some(function (part) {
        return part.cmDeadlineMissed;
      });
    }
    /**
     * Returns true if this is release with urgent workflow.
     */

  }, {
    key: "isUrgent",
    value: function isUrgent() {
      return this.workflowType === ReleaseWorkflowType_1.ReleaseWorkflowType.Urgent || this.workflowType === ReleaseWorkflowType_1.ReleaseWorkflowType.SelloutUrgent;
    }
  }]);

  return AbstractRelease;
}(DomainObject_1.DomainObject);

exports.AbstractRelease = AbstractRelease; // schema base for concrete releases

AbstractRelease.schemaBase = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder('Release');
  return {
    id: builder.id('id'),
    name: builder.str('name'),
    description: builder.opt(builder.str('description').withDescription({
      multiline: true
    })),
    releaseType: builder.senum('releaseType', ReleaseType_1.ReleaseType, CodebookLookupSequence_1.CodebookLookupSequence.ReleaseType),
    created: builder.date('created', DateParser_1.DateParser.ISO_PATTERN),
    createdBy: builder.obj('createdBy', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    }),
    lastModified: builder.date('lastModified', DateParser_1.DateParser.ISO_PATTERN),
    lastModifiedBy: builder.obj('lastModifiedBy', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    }),
    priceListTypeId: builder.lookup('priceListTypeId', CodebookLookupSequence_1.CodebookLookupSequence.PriceListType),
    priceListType: builder.str('priceListType'),
    productCategoryIds: builder.listOf(builder.str('productCategoryIds')),
    workflowType: builder.senum('workflowType', ReleaseWorkflowType_1.ReleaseWorkflowType, CodebookLookupSequence_1.CodebookLookupSequence.ReleaseWorkflowType),
    state: builder.senum('state', ReleaseState_1.ReleaseState, CodebookLookupSequence_1.CodebookLookupSequence.ReleaseState),
    calcWorkflowCaseId: builder.opt(builder.str('calcWorkflowCaseId')),
    exportWorkflowCaseId: builder.opt(builder.str('exportWorkflowCaseId')),
    exportProgressMonitorId: builder.opt(builder.str('exportProgressMonitorId')),
    priceValidityStartDate: builder.opt(builder.date('priceValidityStartDate', DateParser_1.DateParser.ISO_PATTERN)),
    totalPriceChangeLimit: builder.opt(builder.num('totalPriceChangeLimit')),
    exported: builder.opt(builder.date('exported', DateParser_1.DateParser.ISO_PATTERN)),
    cmDeadline: builder.opt(builder.date('cmDeadline', DateParser_1.DateParser.ISO_PATTERN)),
    favourite: builder.bool('favourite'),
    validationResult: builder.obj('validationResult', ValidationResult_1.ValidationResult.schema, function (mat) {
      return new ValidationResult_1.ValidationResult(mat.resultObjects);
    }),
    realImpact: builder.opt(builder.obj('realImpact', RealImpactValue_1.RealImpactValue.schema, RealImpactValue_1.RealImpactValue.ctor)),
    calcProgressMonitorId: builder.opt(builder.str('calcProgressMonitorId')),
    computingProcessId: builder.opt(builder.str('computingProcessId'))
  };
}();